module.exports = __webpack_public_path__ + "img/high_well-being@2x.d2a3908c.png";